export default __webpack_public_path__ + "static/point2-design-dc1736ca7a8d2c962d1f8aa9cb6d5808.webp";